//@ts-nocheck
import {
  Avatar,
  Box,
  Button,
  Collapse,
  Flex,
  Link,
  Stack,
  Text,
  useTheme,
} from "@chakra-ui/react";
import Icon, { XButton } from "./ui-elements/Icon";
import { PhoneIcon } from "@chakra-ui/icons";
import { observer } from "mobx-react-lite";
import React from "react";
import {
  arrayToString,
  greetings,
  possessiveNoun,
  removeClassPrefix,
  shuffle,
} from "../utils/functions";
import {
  BOOKED_LESSONS_STAGE,
  CALL_CLIENT_STAGE,
  CHAT_ACTION,
  CONTACT_CLIENT_ACTION,
  GET_CLIENT_CONTACT_STAGE,
  PAID_LESSON_FEE_STATUS,
  PAID_SPEAKING_FEE_STATUS,
  SUBMITTED_FEEDBACK_STAGE,
  SUBMIT_FEEDBACK_ACTION,
} from "../stores/jobs/utils/request";
const getSubjectNames = (students: any, searchSubject: any) => {
  let subjectsArray = students
    .map(({ classDetail }) => classDetail.subjects)
    .flat();
  shuffle(subjectsArray);

  let subjects = [...new Set([searchSubject, ...subjectsArray])].map(
    (subject) => removeClassPrefix(subject),
  );
  let displaySubjects = subjects.slice(0, students.length + 1);

  if (subjects.length === displaySubjects.length) {
    return arrayToString(displaySubjects);
  }

  return `${displaySubjects.join(", ")} and other subjects`;
};

type Props = {
  assignedSupport: any;
  clientName: string;
  openModal: any;
  lostRequest: any;
  students: Array<any>;
  clientWhatsApp: any;
  searchSubject: any;
  requestStatus: any;
  tutorInfo: any;
  clientHasPaid: boolean;
  clientPhone: any;
  bookingStage: any;
  [key: string]: any;
};

const ContactClient = observer(
  ({
    assignedSupport,
    clientName,
    openModal,
    lostRequest,
    students = [],
    clientWhatsApp,
    searchSubject,
    requestStatus,
    tutorInfo = {},
    clientHasPaid,
    clientPhone,
    bookingStage,
    ...rest
  }: Props) => {
    const [showTip, setShowTip] = React.useState(false);
    const handleToggle = () => setShowTip(!showTip);
    const { colors } = useTheme();

    const currentTime = new Date().getHours();

    let studentNames: string | string[] = students.map((student) =>
      possessiveNoun(student.name),
    );
    studentNames = arrayToString(studentNames);

    const subjects = getSubjectNames(students, searchSubject);
    const textMessage = `${greetings(
      currentTime,
    )} ${clientName},

My name is ${tutorInfo.firstName.trim()} from Tuteria.

Thanks for your interest in engaging my service for ${studentNames} lessons in ${subjects}.

Please let me know when might be a good time to call so I can better understand your goals and prepare ahead of commencing lessons.

I await your response. Thanks again.`;

    const whatsAppChat = `https://wa.me/${clientWhatsApp}?text=${encodeURI(
      textMessage,
    )}`;

    if (
      !clientHasPaid &&
      !lostRequest &&
      bookingStage.current === GET_CLIENT_CONTACT_STAGE
    ) {
      return (
        <Box mx={[0, 6]} p={5} {...rest}>
          <Stack spacing={3} align="center">
            <Box textAlign="center">
              <Avatar
                size="md"
                name={assignedSupport.contactName}
                src={assignedSupport.contactPhoto}
              />
              <Text fontWeight="bold" mt={3}>
                {assignedSupport.contactName} from Tuteria
              </Text>
              <Text opacity={0.8} fontSize="sm">
                Learning Support
              </Text>
            </Box>

            <Stack textAlign="center" align="center" width={["100%", "75%"]}>
              <Text>
                Great job, {tutorInfo.firstName.trim()}! Thanks for accepting{" "}
                {possessiveNoun(clientName)} request. I'm in touch with the
                client to get them to book lessons. I'll let you know once they
                confirm. Hold tight!
              </Text>
            </Stack>

            <Stack align="center">
              <Text>Need to reach me?</Text>
              <XButton
                onClick={() => openModal(CHAT_ACTION)}
                leftIcon={"customer-support"}
              >
                Get in touch
              </XButton>
            </Stack>
          </Stack>
        </Box>
      );
    }

    if (
      clientHasPaid &&
      !lostRequest &&
      bookingStage.current === GET_CLIENT_CONTACT_STAGE
    ) {
      return (
        <Box mx={[0, 6]} p={5} {...rest}>
          <Stack spacing={5} align="center">
            <Box textAlign="center">
              <Avatar
                size="md"
                name={assignedSupport.contactName}
                src={assignedSupport.contactPhoto}
              />
              <Text fontWeight="bold" mt={3}>
                {assignedSupport.contactName} from Tuteria
              </Text>
              <Text opacity={0.8} fontSize="sm">
                Learning Support
              </Text>
            </Box>

            {requestStatus === PAID_SPEAKING_FEE_STATUS && (
              <Stack textAlign="center" align="center" width={["100%", "85%"]}>
                <Text>Great news, {tutorInfo.firstName.trim()}! 🥳 </Text>
                <Text>
                  {clientName} wants to speak with you before booking lessons.
                  This is usually a mini-interview that gives you an opportunity
                  to wow them! We've put together some tips to help you make the
                  most of it. Click this button to get started.
                </Text>
              </Stack>
            )}

            {requestStatus === PAID_LESSON_FEE_STATUS && (
              <Stack textAlign="center" align="center" width={["100%", "85%"]}>
                <Text> Splendid news, {tutorInfo.firstName.trim()}! 🥳</Text>
                <Text>
                  {clientName} has paid for lessons and wants to start soon!
                  Before lessons are booked, you need to contact them to help
                  prepare ahead of your first class. We've put together some
                  tips to help you make the most of it. Click this button to get
                  started.
                </Text>
              </Stack>
            )}

            <Button
              size="lg"
              mt={3}
              onClick={() => openModal(CONTACT_CLIENT_ACTION)}
              colorScheme="blue"
            >
              Get client's contact
            </Button>
          </Stack>
        </Box>
      );
    }

    if (
      clientHasPaid &&
      !lostRequest &&
      bookingStage.current === CALL_CLIENT_STAGE
    ) {
      return (
        <Stack spacing={[5, 6]} px={[5, 6]} {...rest}>
          <Stack spacing={1}>
            <Text fontSize="lg" fontWeight="medium">
              Contact client immediately
            </Text>
            <Text opacity={0.7}>
              Use the number below to speak with the client
            </Text>
          </Stack>

          <Stack spacing={[4, 5]} isInline>
            <Icon name="email" size={[5, 6]} />
            <Box mt={-1}>
              <Text fontWeight="medium">Send a message first</Text>

              <Text opacity={0.8}>
                Introduce yourself via WhatsApp or SMS and ask for the best time
                to call.
              </Text>

              {clientWhatsApp && (
                <Text mt={3} opacity={0.8} onClick={handleToggle}>
                  <span style={{ color: colors.red[500] }}>
                    <b>Pro tip: </b>
                  </span>
                  Copy{" "}
                  <Link textDecoration="underline" color="blue.500">
                    this beautifully crafted message
                  </Link>{" "}
                  to send to clients
                </Text>
              )}

              <Collapse in={showTip}>
                <Stack
                  mt={3}
                  p={[4, 5]}
                  bg="neutral.100"
                  rounded="fbRadius"
                  borderWidth="2xs"
                >
                  <Text>
                    {greetings(currentTime)} {clientName},
                  </Text>

                  <Text>
                    My name is {tutorInfo.firstName.trim()}, and I am a private
                    tutor with Tuteria.
                  </Text>
                  <Text>
                    Thanks for your interest in engaging my service for{" "}
                    {studentNames} lessons in {subjects}.
                  </Text>

                  <Text>
                    Please let me know when might be a good time to call so I
                    can better understand your goals and prepare ahead of
                    commencing lessons.
                  </Text>

                  <Text>I await your response. Thanks again.</Text>

                  <XButton
                    mt={5}
                    as="a"
                    href={whatsAppChat}
                    target="_blank"
                    alignSelf="flex-start"
                    colorScheme="whatsapp"
                    leftIcon={"whatsapp"}
                  >
                    Send message to client
                  </XButton>
                </Stack>
              </Collapse>
            </Box>
          </Stack>

          <Stack spacing={[4, 5]} isInline>
            <Icon name="alarm-clock" size={[5, 6]} />
            <Box mt={-1}>
              <Text fontWeight="medium">Call at the agreed time</Text>

              <Text opacity={0.8}>
                Ensure to call promptly, be professional and friendly. Endeavour
                to better understand their needs and clarify any information you
                need.
              </Text>
            </Box>
          </Stack>

          <Stack spacing={[4, 5]} isInline>
            <Icon name="send-message" size={[5, 6]} />
            <Box mt={-1}>
              <Text fontWeight="medium">Submit feedback afterwards</Text>

              <Text opacity={0.8}>
                When you're done, please click the button below to send us a
                call feedback so that we can book lessons. This is compulsory.
              </Text>
            </Box>
          </Stack>

          <Flex
            pb={2}
            mt={[3, 5]}
            width="100%"
            direction={["column", "row"]}
            align="center"
            justifyContent="space-beween"
          >
            <Box
              bg="blue.50"
              px={3}
              py={1}
              borderRadius="fbRadius"
              textAlign="center"
              as="a"
              href={`tel:${clientPhone}`}
            >
              <Button
                size="lg"
                letterSpacing={1.5}
                color="gray.800"
                variant="link"
                iconSpacing={3}
                leftIcon={<PhoneIcon />}
              >
                {clientPhone}
              </Button>
              <Text fontSize="xs">Client's phone</Text>
            </Box>

            <Button
              mt={[5, 0]}
              size="lg"
              variant="outline"
              ml={["0", "auto"]}
              onClick={() => openModal(SUBMIT_FEEDBACK_ACTION)}
              colorScheme="blue"
            >
              Submit feedback
            </Button>
          </Flex>
        </Stack>
      );
    }

    return (
      <Box mx={[0, 6]} p={5} {...rest}>
        <Stack spacing={5} align="center">
          <Box textAlign="center">
            <Avatar
              size="md"
              name={assignedSupport.contactName}
              src={assignedSupport.contactPhoto}
            />
            <Text fontWeight="bold" mt={3}>
              {assignedSupport.contactName} from Tuteria
            </Text>
            <Text fontSize="sm">Learning Support</Text>
          </Box>

          {bookingStage.current === BOOKED_LESSONS_STAGE && (
            <Stack textAlign="center" align="center" width={["100%", "85%"]}>
              <Text>
                Congrats on getting a new booking, {tutorInfo.firstName.trim()},
                and thanks for booking it in. Our Learning Experience team will
                be in touch with you to provide support towards the lesson
                delivery. Give this your very best, as always. ✌🏼
              </Text>
            </Stack>
          )}

          {requestStatus === PAID_SPEAKING_FEE_STATUS && (
            <Stack textAlign="center" align="center" width={["100%", "85%"]}>
              <Text>
                Thanks for providing feedback, {tutorInfo.firstName.trim()}.
                We'll review your feedback and follow-up on {clientName} to book
                lessons and get started. Do not commence lessons in the
                meantime. We'll be in touch once lessons are booked.
              </Text>
            </Stack>
          )}

          {lostRequest && (
            <Stack textAlign="center" align="center" width={["100%", "85%"]}>
              <Text>
                Sadly, {clientName} has either been unresponsive or has
                indicated that they may not proceed with lessons at this time.
                We'll keep following up through our Marketing team, while we
                work to get you more bookings. Fingers crossed!
              </Text>

              {(bookingStage.current === CALL_CLIENT_STAGE ||
                bookingStage.current === SUBMITTED_FEEDBACK_STAGE) && (
                <Stack spacing={4} align="center">
                  <Text>
                    Why not reach out to the client again and nudge them to book
                    lessons? You may do so, and let me know.
                  </Text>
                  <XButton
                    onClick={() => openModal(CHAT_ACTION)}
                    leftIcon={"customer-support"}
                  >
                    Get in touch
                  </XButton>
                </Stack>
              )}
            </Stack>
          )}

          {!lostRequest && !(bookingStage.current === BOOKED_LESSONS_STAGE) && (
            <Stack align="center">
              <Text>Need to reach me?</Text>
              <XButton
                onClick={() => openModal(CHAT_ACTION)}
                leftIcon={"customer-support"}
              >
                Get in touch
              </XButton>
            </Stack>
          )}
        </Stack>
      </Box>
    );
  },
);

export default ContactClient;
